// Checkout in a modal (the coffee flow) for headers whose cart drawer opens
// checkout in place instead of routing to /checkout. Mount once per header;
// it opens on `openCheckoutModal()` and closes on `close-checkout-modal`,
// which CheckoutPage fires after the order is placed (it then routes home
// with the order confirmation).
import { Suspense, lazy, useEffect, useState } from 'react';
import { Grid } from 'antd';
import AppModal from '@components/base/AppModal';
import { useCopy } from '@/app/providers/useCopy';
import {
  CLOSE_CHECKOUT_MODAL,
  OPEN_CHECKOUT_MODAL,
  loadCheckoutModule,
} from './checkoutModalEvents.js';

const CheckoutPage = lazy(loadCheckoutModule);

export default function CheckoutModal({ className }) {
  const t = useCopy();
  const screens = Grid.useBreakpoint();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    window.addEventListener(OPEN_CHECKOUT_MODAL, handleOpen);
    window.addEventListener(CLOSE_CHECKOUT_MODAL, handleClose);
    return () => {
      window.removeEventListener(OPEN_CHECKOUT_MODAL, handleOpen);
      window.removeEventListener(CLOSE_CHECKOUT_MODAL, handleClose);
    };
  }, []);

  return (
    <AppModal
      kind="checkout"
      open={open}
      footer={null}
      onCancel={() => setOpen(false)}
      width={screens.sm ? 1180 : '100%'}
      destroyOnHidden
      className={['default-checkout-modal', className].filter(Boolean).join(' ')}
      styles={{ body: { padding: 0 }, content: { padding: 0, overflow: 'hidden' } }}
    >
      <Suspense
        fallback={
          <div className="default-checkout-loading">
            {t('loadingCheckout', 'Loading checkout...')}
          </div>
        }
      >
        <CheckoutPage inModal />
      </Suspense>
    </AppModal>
  );
}
